import { render, staticRenderFns } from "./TripDataLocationTemplate.vue?vue&type=template&id=230aab02&"
import script from "./TripDataLocationTemplate.vue?vue&type=script&lang=ts&"
export * from "./TripDataLocationTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports